module.exports = __webpack_public_path__ + "resource/img/image011.705d18bc.png";